export default __webpack_public_path__ + "static/media/13-AboveTheBay.fbfd196a.jpeg";